import { List, ListSubheader } from '@mui/material';

import clsx from 'clsx';
import { ReactElement } from 'react';

import MenuItem from './MenuItem';
import { Menu } from './MenuItems';

interface Props {
  menu: Menu;
}

export default function Section({ menu }: Props): ReactElement | null {
  return (
    <List
      dense
      subheader={
        menu.header ? (
          <ListSubheader component="div" className={clsx('subheader')}>
            {menu.header}
          </ListSubheader>
        ) : undefined
      }
    >
      {menu.items.map((i, index) => (
        <MenuItem key={i.title + index} item={i} />
      ))}
    </List>
  );
}
